var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperationsCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9991 10.739C12.5994 10.739 13.086 11.2257 13.086 11.826V17.239C13.086 17.8393 12.5994 18.3259 11.9991 18.3259C11.3988 18.3259 10.9121 17.8393 10.9121 17.239V11.826C10.9121 11.2257 11.3988 10.739 11.9991 10.739Z",
    fill: "#0F20E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.17391C6.57322 2.17391 2.17391 6.57322 2.17391 12C2.17391 17.4268 6.57322 21.8261 12 21.8261C17.4268 21.8261 21.826 17.4268 21.826 12C21.826 6.57321 17.4268 2.17391 12 2.17391ZM0 12C0 5.37261 5.37261 0 12 0C18.6274 0 23.9999 5.37262 23.9999 12C23.9999 18.6274 18.6274 24 12 24C5.37261 24 0 18.6274 0 12Z",
    fill: "#0F20E8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsCheck);
export default __webpack_public_path__ + "static/media/operations-check.edfb7c7a5ef6682b66ac003c13d4cba9.svg";
export { ForwardRef as ReactComponent };